// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cNSXZ","pages":"styles_pages__Y7mwx","gap":"styles_gap__l1io4"};